// Tiny pure helper shared by the gallery + the Sheet view: is this media item a
// Clip (an animated GIF), versus a still photo (a BMP)? The camera names clips
// GIF_####.gif and photos IMG_####.bmp; the R2 key carries that suffix, so a
// `.gif` extension is the signal. Framework-agnostic (no React import).

/** True when the media key is a Clip (`.gif`) — i.e. eligible for a contact Sheet. */
export function isClip(key: string): boolean {
  return /\.gif$/i.test(key);
}
